import { AfterViewInit, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { CameraScannerService } from '@core/camera-scanner/camera-scanner.service';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-camera-overlay',
  templateUrl: './camera-overlay.component.html',
  styleUrls: ['./camera-overlay.component.scss'],
})
export class CameraOverlayComponent implements OnInit, AfterViewInit {

  @ViewChild('videoRef') videoRef: ElementRef<HTMLVideoElement>;

  showOverlay$: Observable<boolean>;

  constructor(private cameraScannerService: CameraScannerService) { }

  ngOnInit(): void {
    this.showOverlay$ = this.cameraScannerService.showOverlay$;
  }

  ngAfterViewInit(): void {
    // Register the video element once — it stays in the DOM permanently
    this.cameraScannerService.registerVideoElement(this.videoRef.nativeElement);
  }

  cancelScan(): void {
    this.cameraScannerService.stopScan();
  }
}
